
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-3">
            <div className="mb-6">
              <span className="text-sm text-amber-800 font-medium">/ About Us</span>
            </div>

            <h2 className="text-5xl md:text-6xl font-light text-gray-900 leading-tight mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              Dedicated to Healing<br />
              10 Years of Excellence
            </h2>

            <p className="text-base text-gray-600 leading-relaxed mb-12 max-w-2xl">
              We are committed to providing professional and attentive SPA healing services to every client. Using internationally advanced healing techniques combined with traditional Eastern wellness wisdom, we create a unique body and mind relaxation experience for you. Here, you will escape the hustle and bustle of the city and rediscover inner peace and balance.
            </p>

            <div className="grid grid-cols-3 gap-8">
              <div>
                <div className="text-4xl font-light text-amber-900 mb-2">10+</div>
                <div className="text-sm text-gray-600">Years Experience</div>
              </div>
              <div>
                <div className="text-4xl font-light text-amber-900 mb-2">5000+</div>
                <div className="text-sm text-gray-600">Happy Clients</div>
              </div>
              <div>
                <div className="text-4xl font-light text-amber-900 mb-2">98%</div>
                <div className="text-sm text-gray-600">Satisfaction Rate</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="relative">
              <div className="w-full h-[500px] rounded-3xl bg-cover bg-center" style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/e1b3816c8e8b480372f86754f914a7da.jpg)' }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
